import { render } from "./AdminNewsList.vue?vue&type=template&id=01babf29&scoped=true"
import script from "./AdminNewsList.vue?vue&type=script&lang=js"
export * from "./AdminNewsList.vue?vue&type=script&lang=js"

import "./AdminNewsList.vue?vue&type=style&index=0&id=01babf29&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01babf29"]])

export default __exports__